import moment from "moment";
import { IoIosAirplane } from "react-icons/io";

export default function FlightDetails({ flight, i }) {
  return (
    <>

      <tr className="bg-slate-200">
        <td colSpan={4}>
          <div className="flex items-center justify-between">
            <h2 className="font-bold text-lg py-1 flex-1">{i + 1}. {flight.FlightNumber} • {flight.DepartureAirport} - {flight.ArrivalAirport}</h2>
          </div>
        </td>
      </tr>
      <tr>
        <td colSpan={4}>
          <small className="block mt-1">{flight.ElapsedTime}</small>
        </td>
      </tr>
      <tr>
        <td>
          <small className="uppercase text-slate-500 block mb-1">Departing</small>
          <h1 className="text-lg font-bold">{flight.DepartureAirport}</h1>
          <p className="font-medium mb-2">{flight.DepartFullName}</p>
          <p className="text-slate-500 text-sm mb-1">{moment(flight.DepartureDateTime).format('LLL')}</p>
          <p className="text-slate-500 text-sm mb-1">{flight.DepartFullName}</p>
        </td>
        <td align="center" valign="top"><div className="pt-10 flex items-center relative *:absolute justify-center"><hr className="w-full" /><IoIosAirplane className="text-2xl" /></div></td>
        <td>
          <small className="uppercase text-slate-500 block mb-1">Arriving</small>
          <h1 className="text-lg font-bold">{flight.ArrivalAirport}</h1>
          <p className="font-medium mb-2">{flight.ArriveFullName}</p>
          <p className="text-slate-500 text-sm mb-1">{moment(flight.ArrivalDateTime).format('LLL')}</p>
          <p className="text-slate-500 text-sm mb-1">{flight.ArriveFullName}</p>
        </td>
        <td>
          <div className="flex items-start">
            {/* <img className="object-cover me-2" height={32} width={32} src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTgE2Z5dTSfvnUtxLkqwp6iqTBxlH-_ZOhTCg&usqp=CAU" /> */}
            <div className="flex-1">
              <p className="font-medium mb-1">{flight.OperatingAirlineName}</p>
              <small className="uppercase text-slate-400 block">{flight.EquipmentType}</small>
              <span className="block text-orange-700">({flight.ClassOfService})</span>
            </div>
          </div>
        </td>
      </tr >
      <tr>
        <td colSpan={2}>{flight.Banner}</td>
        <th colSpan={2}>Smoking Allowed: {flight.SmokingAllowed}</th>
      </tr>
      <tr><td colSpan={4} className="min-h-5"><span className="invisible">sr-only</span></td></tr>

    </>
  )
}
